<template>
  <Layout v-if="course" hide-bottom-nav-bar>
    <template #center-content>
      <BaseCard
        class="neutral tone-100 px-0"
        hide-divider
      >
        <template #header>
          <router-link
            :to="`/courses/${course.data.id}`"
            class="mt-6  d-flex align-center text-decoration-none"
          >
            <BaseButton
              :ripple="false"
              depressed
              color="transparent"
              :height="32"
              class="px-0"
            >
              <font-awesome-icon
                :icon="$vuetify.breakpoint.mdAndDown ?
                  'fa-regular fa-arrow-left': 'fa-regular fa-arrow-left-long'"
                :class="$vuetify.breakpoint.mdAndDown ? 'brand-secondary--text' : 'neutral--text'"
                size="lg"
              />
            </BaseButton>
            <div
              :class="$vuetify.breakpoint.mdAndDown ?
                'brand-secondary--text text-body-m' : 'neutral--text text-label-s-semi-bold'"
              @click="openDialog = false"
            >
              Retour
            </div>
          </router-link>
        </template>

        <template #content>
          <div class="px-6">
            <div class="mb-10">
              <BaseHeader class="mt-6 mb-6 mt-md-2 mb-md-4 text-center text-md-left neutral--text">
                <span> {{ courseSport.attributes.name }}</span>
              </BaseHeader>
            </div>

            <BaseHeaderDescription class="mb-6 brand-primary--text text-tone-400  text-md-left">
              <template v-if="course.data.attributes.day_and_time">
                {{ $t('You have chosen to subscribe to with day and time',
                      {
                        sport: courseSport.attributes.name,
                        date: course.data.attributes.day_and_time,
                        campus: courseCampuses.map((campus) => campus.attributes.name).join(', ')
                      }
                    )
                }}
              </template>
              <template v-else>
                {{
                  $t('You have chosen to subscribe to without day and time',
                      {
                        sport: courseSport.attributes.name,
                        campus: courseCampuses.map((campus) => campus.attributes.name).join(', ')
                      }
                    )
                }}
              </template>
            </BaseHeaderDescription>

            <div>
              <BaseButton
                :block="$vuetify.breakpoint.mdAndDown"
                color="brand-primary tone-400 white--text"
                @click.native="confirm"
                :loading="subscriptionLoading"
                :disabled="notTheRightProgram"
              >
                {{ $t('Confirm subscription') }}
              </BaseButton>
            </div>
          </div>
        </template>
      </BaseCard>
    </template>
  </Layout>
</template>

<script>
import { isEmpty } from 'lodash';
import Layout from '@/views/containers/Layout.vue';
import BaseCard from '@/components/BaseCard.vue';
import BaseButton from '@/components/BaseButton.vue';
import BaseHeader from '@/components/BaseHeader.vue';
import BaseHeaderDescription from '@/components/BaseHeaderDescription.vue';
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
  name: 'Subscribe',
  components: {
    Layout,
    BaseCard,
    BaseButton,
    BaseHeader,
    BaseHeaderDescription,
  },

  methods: {
    ...mapActions([
      'fetchCourse',
      'setSubscriptionLoading',
      'confirmSubscription',
      'confirmPendingSubscription',
    ]),
    confirm() {
      this.setSubscriptionLoading(true);
      this.confirmSubscription();
    },
  },
  computed: {
    ...mapState(['course', 'subscriptionLoading', 'currentUser', 'pendingSubscription', 'settings']),
    ...mapGetters(['courseSport', 'courseCampuses', 'coursePrograms']),
    notTheRightProgram() {
      return !this.currentUser
        || !this.coursePrograms.some(
          (courseProgram) => courseProgram.id === this.currentUser.attributes.program_id,
        );
    },
  },
  created() {
    this.fetchCourse();
  },
  mounted() {
    if (localStorage.authorization && !isEmpty(this.pendingSubscription)) {
      this.confirmPendingSubscription();
    }
  },
};
</script>
